import { Box, SxProps, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, ButtonProps } from 'system/atoms';

const container: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column'
};

type Props = Omit<ButtonProps, 'loading'> & {
  isLoading: boolean;
  text?: string;
};

export const RefreshButton: React.FC<Props> = ({
  isLoading,
  text,
  ...props
}) => {
  return (
    <Box sx={container}>
      {text && <Typography variant="body1">{text}</Typography>}
      <Button
        variant="tertiary"
        startIcon={<RefreshIcon />}
        loading={isLoading}
        {...props}
      >
        Refresh
      </Button>
    </Box>
  );
};
